import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Col, Container, Row } from "react-bootstrap";
import "animate.css";
import TrackVisibility from "react-on-screen";
import wenno from "../assets/img/wenno.jpg";
import dual from '../assets/img/dual.png'

export const Experience = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <section id="experience">
      <Container>
        <Row>
          <Col>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeInDown" : ""
                  }
                >
                  <div className="skill-bx">
                    <h2>Work Experience</h2>
                    <Carousel
                      responsive={responsive}
                      arrows={false}
                      className="skill-slider"
                    >
                      <div className="item">
                        <h5>Front End Developer || Weenovate</h5>
                        <p>Since may 2022 to dec 2022</p>
                        <img src={wenno} alt="" />
                        <ul>
                          <li>Connection of the backend endpoints</li>
                          <li>Visual problem solving</li>
                          <li>Worked with Angular & SaSS</li>
                        </ul>
                      </div>
                      <div className="item"></div>
                      <div className="item">
                        <h5>Full Stack Developer || Free-Lance</h5>
                        <p>Since may 2020 to this day</p>
                        <img
                          src={dual}
                          alt=""
                        />
                        <ul>
                          <li>Web design and development</li>
                          <li>Front & Back-end</li>
                          <li>Consultation Services</li>
                          <li>UX/UI Design</li>
                        </ul>
                      </div>
                    </Carousel>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
